import React, { useState } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"; 
import defaulUser from "../../../assets/defaultUser.png";
import "../Styles/Goleadores.css";


const GoleadoresComponent = ({ goleadores }) => {
  const golesPorPagina = 5;
  const [paginaActual, setPaginaActual] = useState(1);

  const goleadoresOrdenados = goleadores.sort((a, b) => b.puntos - a.puntos);
  const totalGoleadores = goleadoresOrdenados.length;
  const totalPaginas = Math.ceil(totalGoleadores / golesPorPagina);

  const indexOfLastGoleador = paginaActual * golesPorPagina;
  const indexOfFirstGoleador = indexOfLastGoleador - golesPorPagina;
  const goleadoresPaginaActual = goleadoresOrdenados.slice(indexOfFirstGoleador, indexOfLastGoleador);

  const cambiarPagina = (numeroPagina) => {
    if (numeroPagina >= 1 && numeroPagina <= totalPaginas) {
      setPaginaActual(numeroPagina);
    }
  };

  

  return (
    <div>
      <h3>Goleadores del Torneo</h3>
      {goleadores.length > 0 ? (
        <table className="estadisticas-table">
          <thead>
            <tr>
              <th>#</th>
              <th>Foto</th>
              <th>Nombre</th>
              <th>Apellido</th>
              <th>Número de Camiseta</th>
              <th>Goles</th>
              <th>Equipo</th>
            </tr>
          </thead>
          <tbody>
            {goleadoresPaginaActual.map((goleador, index) => (
              <tr key={goleador.idJugador}>
                <td>{indexOfFirstGoleador + index + 1}</td>
                <td>
                  <img
                    src={goleador.fotografiaPath || defaulUser}
                    alt={`${goleador.nombreJugador} Foto`}
                    className="goleador-foto"
                  />
                </td>
                <td>{goleador.nombreJugador}</td>
                <td>{goleador.apellidoJugador || "N/A"}</td>
                <td>{goleador.numeroCamiseta || "N/A"}</td>
                <td>{goleador.goles || 0}</td>
                <td>{goleador.nombreEquipo || "Sin Equipo"}</td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan="7" className="paginacion">
                    <button
                    onClick={() => cambiarPagina(paginaActual - 1)}
                    disabled={paginaActual === 1}
                    >
                    <FaChevronLeft />
                    </button>
                <span>
                  Página {paginaActual} de {totalPaginas}
                </span>
                <button
                  onClick={() => cambiarPagina(paginaActual + 1)}
                  disabled={paginaActual === totalPaginas}
                >
                  <FaChevronRight />
                </button>
              </td>
            </tr>
          </tfoot>
        </table>
      ) : (
        <p>No hay goleadores registrados aún.</p>
      )}
    </div>
  );
};

export default GoleadoresComponent;
